import { createSQLiteAdapter } from "./SQLiteAdapter";
import { createDexieAdapter } from "./DexieAdapter";

// CW Browser (Electron) → SQLite via IPC | Web browser → IndexedDB via Dexie
const db = window.electronAPI?.db
  ? createSQLiteAdapter()
  : createDexieAdapter();

export default db;
